import labels from "./Petriplate.json";

export const renderBoxes = (canvas, boxes, showLabels = true) => {

  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  if (!showLabels) return;

  const colors = new Colors();

  const fontSize = Math.max(
    Math.round(Math.max(canvas.width, canvas.height) / 40),
                            14
  );

  ctx.font = `${fontSize}px Arial`;
  ctx.textBaseline = "top";

  const labelCounts = {};

  boxes.forEach((box) => {

    // -------- EXPECT XYXY --------
    let [x1, y1, x2, y2] = box.bounding;

    // -------- CONVERT --------
    let w = x2 - x1;
    let h = y2 - y1;

    // -------- SAFETY --------
    if (
      !isFinite(x1) || !isFinite(y1) ||
      !isFinite(x2) || !isFinite(y2) ||
      w <= 0 || h <= 0
    ) return;

    // clamp to canvas
    x1 = Math.max(0, Math.min(canvas.width, x1));
    y1 = Math.max(0, Math.min(canvas.height, y1));
    w = Math.min(canvas.width - x1, w);
    h = Math.min(canvas.height - y1, h);

    const klass = labels[box.label] || "colony";
    const color = colors.get(box.label);

    // -------- DRAW --------
    ctx.fillStyle = Colors.hexToRgba(color, 0.2);
    ctx.fillRect(x1, y1, w, h);

    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.strokeRect(x1, y1, w, h);

    if (!labelCounts[klass]) {
      labelCounts[klass] = { count: 0, color };
    }

    labelCounts[klass].count++;
  });

  // -------- PANEL --------
  const padding = 10;
  const lineHeight = fontSize + 6;

  const entries = Object.entries(labelCounts);

  ctx.fillStyle = "rgba(0,0,0,0.6)";
  ctx.fillRect(10, 10, 180, entries.length * lineHeight + padding * 2);

  entries.forEach(([name, data], i) => {
    ctx.fillStyle = data.color;
    ctx.fillText(`${name}: ${data.count}`, 20, 20 + i * lineHeight);
  });
};


class Colors {
  constructor() {
    this.palette = [
      "#FF3838","#FF9D97","#FF701F","#FFB21D","#CFD231",
      "#48F90A","#92CC17","#3DDB86","#1A9334","#00D4BB",
      "#2C99A8","#00C2FF","#344593","#6473FF","#0018EC",
      "#8438FF","#520085","#CB38FF","#FF95C8","#FF37C7"
    ];
    this.n = this.palette.length;
  }

  get(i) {
    return this.palette[i % this.n];
  }

  static hexToRgba(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
}
